import styled from 'styled-components';
import { Type } from '@spotify-internal/encore-web';
export const NotificationIndicator = styled(Type).attrs({ as: 'div' }) `
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  top: 0.1rem;
  right: -0.45rem;
  width: 1.2rem;
  height: 1.2rem;
  font-size: 0.625rem;
  font-weight: bold;
  color: white;
  overflow: hidden;
  text-align: center;
  border: 2px solid white;
  background-color: #f15e6c;
  border-radius: 100%;
`;
//# sourceMappingURL=NotificationIndicator.js.map